// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"127":"d229470b7f964dbc","184":"55e4ecc31fb4580e","189":"90495c756f935cdf","754":"23e6f31d84c2c2cc"}[chunkId] + ".js";
};